/*
 * @Author       : yiyang
 * @Date         : 2020-06-10 16:31:57
 * @LastEditors  : yiyang
 * @LastEditTime : 2020-12-21 11:22:52
 * @PRD          : 
 * @Description  : 
 * @FilePath     : /work/yit_fe_shangbo/src/utils/utils.js
 * @URL          : 
 */ 
import config from "config/default"

const { cdnUrl } = config

/**
 * 根据主题获取主题颜色
 * @param theme 
 */
export const getThemeColor = theme => {
    switch (theme) {
        case 'fjys':
            return {
                default: '#394867',
                light: '#9FA0B4',
            }
        case 'fgxyp':
            return {
                default: '#942D2D',
                light: '#C89697',
            }
        case 'swhs':
            return {
                default: '#3b6636',
                light: '#5a9c50',
            }
        case 'hsh':
            return {
                default: '#687E86',
                light: '#687E86',
            }
        default:
            return {
                default: '#000000',
                light: '#666666',
            }
    }
}

/**
 * 获取完整的文件链接
 * @param prefix
 * @param url 
 */
export const getFileUrl = (prefix, url) => {
    return `${cdnUrl}/${prefix}${url}`
}
